/**
 * Customers on an LC price code have every price display rewritten by the back end
 * (Extensions/Modules/RealTimePricing/Handlers/GetRealtimePricingHandler/700_GetPricingResult.cs)
 * into the combined form "<s>originalPrice</s> lcPrice", so the original can be shown struck
 * through next to the price they actually pay. That belongs in a quantity break table; wherever a
 * single price is shown, only the price the customer will pay should appear.
 */

const closingTag = "</s>";

/** True when a price display carries the LC struck-original-plus-actual-price markup. */
export const hasStruckPrice = (priceDisplay?: string | null): boolean => /<s>/i.test(priceDisplay ?? "");

/**
 * Reduces an LC price display to just the price the customer will pay, which is always what
 * follows the final closing tag. Reading from that tag instead of matching tag pairs keeps the
 * result correct even for a pricing result that was wrapped more than once.
 */
export const stripStruckPrice = (priceDisplay: string): string => {
    const lastClosingTag = priceDisplay.toLowerCase().lastIndexOf(closingTag);
    return (lastClosingTag === -1 ? priceDisplay : priceDisplay.slice(lastClosingTag + closingTag.length)).trim();
};
